<template>
  <div class="global-filter-item">
    <div style="display: flex; align-items: center; position: relative">
      <span class="global-filter-index">{{ localGlobalFilter.globalFilterIndex }}</span>
      <t-input
        v-model="localGlobalFilter.globalFilterName"
        style="margin-right: 12px; width: 200px"
        @blur="handleGlobalFilterNameChange"
      ></t-input>
      <t-button @click="handleAddConditionModels" variant="outline" style="font-size: 12px">
        <icon name="add" slot="icon"></icon>
        筛选项
      </t-button>
      <icon name="delete" class="remove-btn" @click="$emit('delete')" v-if="showDelete" />
    </div>

    <div class="filter" v-if="localGlobalFilter.conditionModels && localGlobalFilter.conditionModels.length">
      <ConditionFilter
        v-if="conditionPropertyOptions.length && conditionOperatorOptions.length"
        :filter-type.sync="localGlobalFilter.connectors"
        :filter-list="localGlobalFilter.conditionModels"
        :condition-operator-options="conditionOperatorOptions"
        :condition-property-options="conditionPropertyOptions"
      />
    </div>
  </div>
</template>

<script>
import lodash from 'lodash';
import ConditionFilter from '@/components/analysis/condition-filter.vue';

export default {
  name: 'GlobalFilterItem',
  components: {
    ConditionFilter,
  },
  model: {
    prop: 'globalFilter',
    event: 'change',
  },
  props: {
    globalFilter: {
      type: Object,
    },
    index: {
      type: Number,
    },
    conditionPropertyOptions: {
      type: Array,
      default: () => [],
    },
    conditionOperatorOptions: {
      type: Array,
      default: () => [],
    },
    showDelete: {
      type: Boolean,
    },
  },
  data() {
    return {
      canAutoModifyGlobalFilterName: true,
      localGlobalFilter: lodash.cloneDeep(this.globalFilter),
    };
  },
  watch: {
    globalFilter: {
      handler() {
        if (JSON.stringify(this.globalFilter) !== JSON.stringify(this.localGlobalFilter)) {
          this.localGlobalFilter = lodash.cloneDeep(this.globalFilter);
        }
      },
      deep: true,
    },
    localGlobalFilter: {
      handler() {
        this.$emit('change', lodash.cloneDeep(this.localGlobalFilter));
      },
      deep: true,
    },
    'localGlobalFilter.conditionModels': {
      handler() {
        if (!this.canAutoModifyGlobalFilterName) {
          return;
        }
        this.localGlobalFilter.globalFilterName = this.generatedGlobalFilterName();
      },
      deep: true,
    },
  },
  methods: {
    handleGlobalFilterNameChange() {
      this.canAutoModifyGlobalFilterName = !this.localGlobalFilter.globalFilterName;
      if (this.canAutoModifyGlobalFilterName) {
        this.localGlobalFilter.globalFilterName = this.generatedGlobalFilterName();
      }
    },
    handleAddConditionModels() {
      if (this.localGlobalFilter.conditionModels.length >= 5) {
        this.$message.warning('最多添加5个筛选项');
        return;
      }
      this.localGlobalFilter.conditionModels.push({
        column: '',
        conditionOperator: '',
        chineseName: '',
        value: undefined,
      });
    },
    generatedGlobalFilterName() {
      const values = [];
      this.localGlobalFilter.conditionModels.forEach(item => {
        if (item.value) {
          const p = this.conditionPropertyOptions.find(
            option => option.name === item.column && option.propertyType === 2,
          );
          if (p) {
            values.push(item.value);
          }
        }
      });
      return values.length ? values.join(',') : '全体用户';
    },
  },
};
</script>

<style scoped lang="less">
.global-filter-item {
  width: 100%;
  background: #fafafa;
  border-radius: 4px;
  margin-bottom: 12px;
  box-sizing: border-box;
  padding: 12px 20px;

  .global-filter-index {
    width: 20px;
    height: 20px;
    box-sizing: border-box;
    border-radius: 50%;
    border: 1px solid #5a66ff;
    font-weight: bold;
    font-size: 14px;
    color: #5a66ff;
    line-height: 18px;
    margin-right: 8px;
    text-align: center;
  }

  .filter {
    margin-top: 10px;
    padding: 10px 0 10px 0;
    background-color: #fafafa;
    &:hover {
      //background-color: #fafafa;
    }

    .filter-relation {
      display: flex;
      align-items: center;
    }
  }

  .remove-btn {
    position: absolute;
    right: 0;
  }
}
</style>
